module.exports = __webpack_public_path__ + "./docs/img/big-icon-error_class.6ede7929a8e3ee74f7294cf0f088e31f.svg";